var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('BasePageTitle',{attrs:{"title":_vm.$t('clientOverview.pageTitle'),"subtitle":_vm.$t('clientOverview.subTitle')}}),_c('ClientOverviewTable',{on:{"selectClient":_vm.selectClient}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }